import FilterPanel from "../components/FilterPanel";
import SearchBar from "../components/SearchBar";
import SortDropdown from "../components/SortDropdown";
import BusinessList from "../components/BusinessList";
import { useLazyGetBusinessesQuery } from "../api/businessApi";
import { useEffect, useMemo, useState } from "react";

export default function BusinessDirectory() {
  const [filters, setFilters] = useState({
    occupation: "",
    tag: "",
    industry: "",
    sponsored: false,
    internship: false,
  });
  const [search, setSearch] = useState("");
  const [sort, setSort] = useState("A-Z");
  // const observerRef = useRef();
  // const lastBusinessElementRef = useCallback(
  //   (node) => {
  //     if (isLoadingMore) return;
  //     if (observerRef.current) observerRef.current.disconnect();
  //     observerRef.current = new IntersectionObserver((entries) => {
  //       if (entries[0].isIntersecting && hasMore) {
  //         setCurrentPage((prevPage) => prevPage + 1);
  //       }
  //     });
  //     if (node) observerRef.current.observe(node);
  //   },
  //   [isLoadingMore, hasMore]
  // );

  // Fetch businesses from API with pagination
  const [getBuisness, { data: businessesData, isError, error, isFetching }] =
    useLazyGetBusinessesQuery();
  useEffect(() => {
    getBuisness({
      page: 0,
      limit: 0, // Adjust limit as needed
    });
  }, [getBuisness]);

  const allTags = Array.from(
    new Set((businessesData?.businesses || []).flatMap((b) => b.badges || []))
  );
  const allIndustries = Array.from(
    new Set((businessesData?.businesses || []).flatMap((b) => b.industry || []))
  ).sort((a, b) => a.localeCompare(b));
  const alltype = ["Business", "Professional"];

  // Filtering and sorting logic on API data
  const filteredBusinesses = useMemo(() => {
    let result = (businessesData?.businesses || []).filter((b) => {
      const occupation = b.occupation?.trim().toLowerCase();
      const filterOccupation = filters.occupation?.trim().toLowerCase();

      const matchesType = !filterOccupation
        ? true
        : filterOccupation === "business"
        ? occupation === "business"
        : filterOccupation === "professional"
        ? occupation !== "business"
        : true;

      const matchesTag =
        !filters.tag ||
        (b.badges || [])
          .map((badge) => badge.trim().toLowerCase())
          .includes(filters.tag.trim().toLowerCase());

      const matchesindustry =
        !filters.industry ||
        (filters.industry === "Other Services"
          ? b.other_service
          : b.industry?.trim().toLowerCase() ===
            filters.industry.trim().toLowerCase());

      const matchesSearch =
        !search ||
        b.name?.toLowerCase().includes(search.toLowerCase()) ||
        b.company_name?.toLowerCase().includes(search.toLowerCase()) ||
        b.designation?.toLowerCase().includes(search.toLowerCase()) ||
        b.description?.toLowerCase().includes(search.toLowerCase());

      const matchesInternship = !filters.internship || !!b.internship;

      return (
        matchesType &&
        matchesTag &&
        matchesindustry &&
        matchesSearch &&
        matchesInternship
      );
    });

    if (sort === "A-Z")
      result = [...result].sort((a, b) => a.name.localeCompare(b.name));
    if (sort === "Z-A")
      result = [...result].sort((a, b) => b.name.localeCompare(a.name));

    if (filters.industry) {
      result.sort((a, b) => {
        if (a.level2_sponsored && !b.level2_sponsored) return -1;
        if (!a.level2_sponsored && b.level2_sponsored) return 1;

        if (a.sponsored && !b.sponsored) return -1;
        if (!a.sponsored && b.sponsored) return 1;

        return a.name.localeCompare(b.name);
      });
    } else {
      const sponsored = result.filter((b) => b.sponsored);
      const others = result.filter((b) => !b.sponsored);
      result = filters.sponsored ? sponsored : [...sponsored, ...others];
    }

    return result;
  }, [businessesData?.businesses, filters, search, sort]);

  if (isError) {
    return (
      <div className="flex pt-20 md:px-6 lg:px-8 container flex-col justify-center items-center h-[60vh] w-full text-red-600">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="48"
          height="48"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          strokeWidth="2"
          className="mb-2"
        >
          <circle
            cx="12"
            cy="12"
            r="10"
            stroke="currentColor"
            strokeWidth="2"
            fill="none"
          />
          <path
            d="M12 8v4m0 4h.01"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
        <span className="text-lg font-semibold">
          Failed to load businesses.
        </span>
        <span className="text-sm mt-1">
          {error?.data?.message || error?.error || "Unknown error occurred."}
        </span>
      </div>
    );
  }

  return (
    <div className="font-inter pt-20 h-full  mt-2 px-4 lg:px-8">
      {/* Filter Panel */}
      <div className=" w-full lg:w-[320px] lg:mb-0 ">
        <h1 className="md:text-[30px] m-0 flex items-start justify-start text-xl mb-5 font-semibold w-full text-[#135879]">
          Business Directory
        </h1>
      </div>
      <main className="w-full lg:flex-row flex-col  flex items-center lg:items-start lg:justify-start gap-8">
        <div className="rounded-xl lg:sticky lg:top-[0rem] w-full lg:w-[25%] border border-gray-200 shadow-md font-sans bg-white">
          <button className="w-full flex justify-between items-center p-4 cursor-pointer">
            <div className="flex items-center gap-2 text-sm font-semibold text-gray-800">
              <svg
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#222"
                strokeWidth="2"
              >
                <line x1="4" y1="21" x2="4" y2="14" />
                <line x1="4" y1="10" x2="4" y2="3" />
                <line x1="12" y1="21" x2="12" y2="12" />
                <line x1="12" y1="8" x2="12" y2="3" />
                <line x1="20" y1="21" x2="20" y2="16" />
                <line x1="20" y1="12" x2="20" y2="3" />
                <circle cx="4" cy="12" r="2" />
                <circle cx="12" cy="10" r="2" />
                <circle cx="20" cy="14" r="2" />
              </svg>
              Filter
            </div>
            <span
              className="text-[#518AC8] text-base font-semibold ml-auto hover:underline"
              onClick={() =>
                setFilters({
                  type: "",
                  tag: "",
                  industry: "",
                  sponsored: false,
                  internship: false,
                })
              }
            >
              Clear all
            </span>
          </button>

          <div className="p-4">
            <FilterPanel
              filters={filters}
              tags={allTags}
              industries={[...allIndustries, "Other Services"]}
              onFilterChange={setFilters}
              type={alltype}
            />
          </div>
        </div>
        {/* Main Content */}
        <div className="flex-1 w-full">
          <div className="lg:sticky lg:top-[0rem] z-10  bg-white p-2  ">
            <div className="flex gap-8  mb-4 flex-col lg:flex-row items-center justify-center ">
              <SearchBar value={search} onChange={setSearch} />
              <SortDropdown value={sort} onChange={setSort} />
            </div>
          </div>
          {isFetching ? (
            <div className="flex justify-center items-center py-8">
              <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-[#135879] mr-3"></div>
              <span className="text-sm font-medium text-[#135879]">
                Loading businesses...
              </span>
            </div>
          ) : (
            <BusinessList
              businesses={filteredBusinesses?.length && filteredBusinesses}
            />
          )}
        </div>
      </main>
    </div>
  );
}
